import { useMutation } from '@tanstack/react-query';
import { getAuthService } from '../ports/auth-service.registry';
import { backendAuthService } from '../services/backend-auth.service';
import { useAuthStore } from '../stores/authStore';
import type { LoginCredentials, AuthenticationResponse } from '../types/auth.types';

export function useLogin(): {
  login: (variables: LoginCredentials) => void;
  isLoading: boolean;
  error: Error | null;
  isSuccess: boolean;
} {
  const setUser = useAuthStore((state) => state.setUser);

  const mutation = useMutation<AuthenticationResponse, Error, LoginCredentials>({
    mutationFn: async (credentials: LoginCredentials) => {
      const authService = getAuthService();
      await authService.loginWithEmail(credentials.email, credentials.password);
      const token = await authService.getIdToken();
      if (!token) throw new Error('Failed to get Firebase token');
      return backendAuthService.authenticate(token);
    },
    onSuccess: (data) => {
      setUser(data.user);
      // Token is managed by auth provider - retrieved fresh via token adapter when needed
    },
  });

  return {
    login: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
  };
}
